import { tap, compose, map, join, split, type } from "./utils";
import { Left, Right } from "./monads";

const defaults = {
	credentials: "same-origin",
	method: "POST",
};

export const URI = {
	fromObject: (obj) => {
		const encodeComponents = compose(join("="), map(encodeURIComponent));
		return Object.entries(obj).map(encodeComponents).join("&");
	},
	toObject: (uri) => {
		const decodeComponents = compose(map(decodeURIComponent), split("="));
		return Object.fromEntries(uri.split("&").map(decodeComponents));
	},
};

export const parseURL = (uri, parameters) => {
	if (type("object")(parameters) && Object.keys(parameters).length) {
		return `${uri}?${URI.fromObject(parameters)}`;
	}
	return uri;
};

const body = (method, parameters) => {
	if (method === "POST") {
		return tap(new FormData())((data) => {
			Object.entries(parameters).forEach(([key, value]) => {
				data.append(key, value);
			});
		});
	} else {
		return JSON.stringify(parameters);
	}
};

export default async (uri, parameters) => {
	const { $method, ...others } = Object.assign({ $method: "POST" }, parameters);
	const url = $method === "POST" ? uri : parseURL(uri, others);
	const init = { ...defaults, method: $method, body: body($method, others) };

	const response = await fetch(url, init);

	if (response.ok) {
		if (response.headers.get("Content-Type") === "application/json") {
			const { data, error } = await response.json();
			return error ? Left(error) : Right(data);
		} else {
			return Right(await response.text());
		}
	} else {
		return Left({ status: response.status, error: response.statusText });
	}
};
